import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AppError, PurchaseTitleRequest, TitleAvailability, TitlePurchase } from '@core/api';

export const buyTitlesActions = createActionGroup({
  source: 'Land Registry/Buy Titles',
  events: {
    'Check Availability': props<{ titleNumber: string }>(),
    'Check Availability Success': props<{ availability: TitleAvailability }>(),
    'Check Availability Fail': props<{ error: AppError }>(),
    'Purchase Title': props<{ titleNumber: string; request: PurchaseTitleRequest }>(),
    'Purchase Title Success': props<{ purchase: TitlePurchase }>(),
    'Purchase Title Fail': props<{ error: AppError }>(),
    'Reset Buy Titles Flow': emptyProps(),
  },
});

export const purchasesActions = createActionGroup({
  source: 'Land Registry/Purchases',
  events: {
    'Fetch Titles': props<{ titleNumber: string }>(),
    'Fetch Titles Success': props<{ titles: TitlePurchase[] }>(),
    'Fetch Titles Fail': props<{ error: AppError }>(),
    'Download Document': props<{ titleNumber: string; purchaseId: string }>(),
    'Download Document Success': props<{ titleNumber: string; purchaseId: string }>(),
    'Download Document Fail': props<{ error: AppError }>(),
  },
});
